// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Bj-z","tupacHeader":"Cj-z","tupacHeader2":"Dj-z","tupacMenu":"Ej-z","tupacMenu2":"Fj-z","tupacMain":"Gj-z","tupacMain2":"Hj-z"};